import { detect } from 'detect-browser';
import { trackTrace } from './telemetry/telemetry-channel';
const browser = detect();
trackTrace(`BrowserDetect: browser = ${JSON.stringify(browser)}`);
export const browserName = browser && browser.name ? browser.name : 'unknown';
